<template>
  <div class="store-wrapper">
    <div>
      <div>
        <base-title
          :title="StringLanguage.moduleStore"
          subtitle="Adquira novos módulos para sua assinatura"
        >
          <div v-if="isMobile">
            <div
              v-for="(category, categoryIndex) in categories"
              :key="`category${categoryIndex}`"
              class="menu-button mb_20"
            >
              <a>{{ category.name }}</a>
            </div>
          </div>
          <div v-else class="d-flex justify-between mr_30">
            <div
              v-for="(category, categoryIndex) in categories"
              :key="`category${categoryIndex}`"
              class="menu-button"
            >
              <span
                v-if="categoryIndex > 0 && categoryIndex < categories.length"
                >/</span
              >
              <a class="mx_20">{{ category.name }}</a>
            </div>
          </div>
        </base-title>
      </div>
    </div>
    <div class="ads-container row py_15">
      <div class="modules_ads_col col-md-6 col-sm-12 pr_15 py_15">
        <img
          src="@/assets/img/module_store/module_image.png"
          class="module_store_img w-100"
        />
      </div>
      <div class="modules_ads_col col-md-6 col-sm-12 pl_15 py_15">
        <img
          src="@/assets/img/module_store/module_image2.png"
          class="module_store_img w-100"
        />
      </div>
    </div>
    <div v-if="isMobile" class="d-flex ofx-scroll mb_30 no-scrollbar">
      <div
        v-for="(category, categoryIndex) in categories"
        :key="`category${categoryIndex}`"
        class="mobile-menu-button py_10"
        :class="{ ml_20: categoryIndex > 0, 'menu-active': categoryIndex == 0 }"
      >
        <a class="mx_20">{{ category.name }}</a>
      </div>
    </div>
    <div class="modules-container row d-flex flex-wrap align-stretch">
      <div
        v-for="(module, moduleIndex) in modules"
        :key="moduleIndex"
        class="col-xs-12 col-sm-6 col-md-4 d-flex align-stretch modules-items"
      >
        <base-box>
          <div class="card-content">
            <div class="card-display mb_25 aspect_ratio_16_9"></div>
            <div class="card-title mb_20">{{ module.name }}</div>
            <div class="card-description mb_20">{{ module.description }}</div>
            <div class="card-price mb_25">
              {{ Utils.convertMoney(module.price) }}
              <span class="card-period">{{ module.period }}</span>
            </div>
          </div>
          <div class="card-actions">
            <base-button
              text="Detalhes"
              design="four"
              class="mr_15"
              @click="showModuleDrawerDetail(module)"
            />
            <base-button
              text="Adicionar"
              @click="addToCart(module)"
            />
          </div>
        </base-box>
      </div>
    </div>
    <base-drawer
      :open="drawerDetail.open"
      @onClose="drawerDetail.detail = null"
      :title="drawerDetail.detail && drawerDetail.detail.name"
    >
      <module-detail v-if="drawerDetail.detail" :module="drawerDetail.detail" />
      <template slot="footer">
        <base-button
          text="ADICIONAR AO CARRINHO"
          class="w-100"
          @click="addToCart(module)"
        />
      </template>
    </base-drawer>

    <base-drawer
      :open="cartDrawer.open"
      :close="cartDrawer.close"
      title="Resumo do pedido"
    >
      <module-cart
        :items="cart"
        :card="card"
        @removeItem="removeItem"
        @checkout="doCheckout"
        @changeCard="cardSelectorDrawer.open = !cardSelectorDrawer.open"
      />
    </base-drawer>

    <module-card-selector
      :open="cardSelectorDrawer.open"
      :close="cardSelectorDrawer.close"
      @onSelectCard="selectCard"
      @onCardAdded="doCheckout"
    />

    <module-success-drawer
      :open="successDrawer.open"
      :close="successDrawer.close"
    />

    <module-error-drawer
      :open="errorDrawer.open"
      :close="errorDrawer.close"
      @closeDrawer="errorDrawer.close = !errorDrawer.close"
    />

    <a
      v-if="!drawerDetail.detail && cart.length > 0"
      class="fixed-button"
      @click="cartDrawer.open = !cartDrawer.open"
    >
      <i class="fas fa-shopping-basket" />
    </a>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Utils from "@/utils";
import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseBox from "@/components/Box";
import BaseDrawer from "@/components/Drawer";
import BaseCard from "@/components/Card";
import ModuleDetail from "@/containers/ModuleStore/Detail";
import ModuleCart from "@/containers/ModuleStore/Cart";
import ModuleCardSelector from "@/containers/ModuleStore/CardSelector";
import ModuleSuccessDrawer from "@/containers/ModuleStore/Success";
import ModuleErrorDrawer from "@/containers/ModuleStore/Error";
import modules from "@/api/modules.json";

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseDrawer,
    BaseCard,
    ModuleDetail,
    ModuleCart,
    ModuleCardSelector,
    ModuleSuccessDrawer,
    ModuleErrorDrawer,
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  data() {
    return {
      Utils,
      modules,
      cart: [],
      card: null,
      categories: [
        { name: "AVULSO", alias: "AVULSO" },
        { name: "COMBO", alias: "COMBO" },
        { name: "SUGESTÕES", alias: "SUGESTOES" },
        { name: "LANÇAMENTOS", alias: "LANÇAMENTOS" },
      ],
      drawerDetail: {
        open: false,
        detail: null,
      },
      cartDrawer: {
        open: false,
        close: false,
      },
      cardSelectorDrawer: {
        open: false,
        close: false,
      },
      successDrawer: {
        open: false,
        close: false,
      },
      errorDrawer: {
        open: false,
        close: false,
      },
    };
  },
  methods: {
    showModuleDrawerDetail(detail) {
      this.drawerDetail.detail = detail;
      this.drawerDetail.open = !this.drawerDetail.open;
    },
    addToCart(module) {
      const aliasesInCart = this.cart.map((m) => m.alias);
      if (!aliasesInCart.includes(module.alias)) {
        const clonedModule = JSON.parse(JSON.stringify(module));
        this.cart.push(clonedModule);
      }
    },
    removeItem(module) {
      const aliasesInCart = this.cart.map((m) => m.alias);
      const newSetAliases = aliasesInCart.filter(
        (mAlias) => mAlias != module.alias
      );
      this.cart = [...modules.filter((m) => newSetAliases.includes(m.alias))];
      console.log(this.cart);
      if (this.cart.length == 0) {
        this.cartDrawer.close = !this.cartDrawer.close;
      }
    },
    selectCard() {
      this.cardSelectorDrawer.close = !this.cardSelectorDrawer.close;
    },
    doCheckout() {
      this.errorDrawer.open = !this.errorDrawer.open;

      // this.cardSelectorDrawer.close = !this.cardSelectorDrawer.close;
      // this.cartDrawer.close = !this.cartDrawer.close;
      // this.cart = [];
      // this.successDrawer.open = !this.successDrawer.open;
    },
  },
};
</script>
<style scoped>
.store-wrapper {
  position: relative;
}

.fixed-button {
  position: fixed;
  top: 102px;
  right: 46px;
  width: 60px;
  height: 60px;
  background: transparent linear-gradient(90deg, #0099ff 0%, #0088dd 100%) 0% 0%
    no-repeat padding-box;
  box-shadow: 0px 1px 6px #00000029;
  border-radius: 500px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.fixed-button i {
  color: white;
  font-size: 20px;
  opacity: 1;
}

.card-title {
  text-align: left;
  font: normal normal 900 16px/19px Lato;
  letter-spacing: 0px;
  color: #777777;
  opacity: 1;
}

.card-description {
  text-align: left;
  font: normal normal 300 14px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
  height: 58px; /* 3 linhas de 19px */
  /* max line limit */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.card-price {
  text-align: left;
  font: normal normal bold 18px/22px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.card-period {
  text-align: left;
  font: normal normal 300 18px/22px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
  text-transform: lowercase;
}

.card-actions {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.card-actions button {
  flex: 1;
}

.aspect_ratio_16_9 {
  position: relative;
  background-color: #0088dd1a;
}

.aspect_ratio_16_9 .content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.aspect_ratio_16_9::after {
  position: relative;
  display: block;
  content: " ";
  padding-bottom: 56.25%; /* 16:9 -> 9/16 -> 56.25% de altura */
}

.menu-button {
  text-align: right;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.menu-button a {
  cursor: pointer;
}

.mobile-menu-button {
  background: #d4e6f3 0% 0% no-repeat padding-box;
  border-bottom: 2px solid #0099ff80;
  opacity: 1;
  text-align: center;
  font: normal normal normal 16px/19px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.mobile-menu-button.menu-active {
  background: #0099ff80 0% 0% no-repeat padding-box;
  border-bottom: 2px solid #0099ff80;
  opacity: 1;
  text-align: center;
  font: normal normal normal 16px/19px Lato;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.ads-container .module_store_img {
  box-shadow: 0px 1px 6px #00000029;
  border-radius: 8px;
}

.modules-container > .modules-items > .box {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.card-content {
  flex: 1;
}
</style>